import {
  LucideIcon,
  ListChecks,
  Newspaper,
  BookOpen,
  Archive,
  FileText,
  Users,
  Banknote,
  Unlock,
  LogIn,
  PenLine,
  ClipboardCheck,
  Send,
  Shield,
  AlertCircle,
  Calendar,
  User,
} from 'lucide-react';

export type NavItem = {
  name: string;
  path: string;
  icon?: LucideIcon;
  children?: NavItem[];
  isCTA?: boolean;
  state?: Record<string, unknown>;
};

/**
 * The pages in the nav are identical across every theme -- only how they're drawn
 * differs. Moved verbatim out of Navbar.tsx's component body (previously hardcoded
 * inline, not shared/data-driven).
 */
export const standardNavItems: NavItem[] = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Editorial Board', path: '/editorial-board' },
  {
    name: 'Publications',
    path: '/articles',
    children: [
      { name: 'Articles', path: '/articles', icon: Newspaper },
      { name: 'Latest Issue', path: '/articles', state: { goToLatest: true }, icon: BookOpen },
      { name: 'Journal Archive', path: '/journal-archives', icon: Archive },
    ],
  },
  {
    name: 'Guidelines',
    path: '/guidelines',
    children: [
      { name: 'Authors Guidelines', path: '/for-authors', icon: FileText },
      { name: 'Reviewers Guidelines', path: '/for-reviewers', icon: Users },
      { name: 'Peer Review Policy', path: '/peer-review-policy', icon: Shield },
      { name: 'Our Editorial Process', path: '/editorial-process', icon: ListChecks },
      { name: 'Journal Policies', path: '/guidelines', icon: BookOpen },
      { name: 'Article Processing Charges (APC)', path: '/guidelines#author-charges-policy', icon: Banknote },
      { name: 'Open Access Statement', path: '/open-access-statement', icon: Unlock },
    ],
  },
  { name: 'Contact', path: '/contact' },
  {
    name: 'Login',
    path: '/author/login',
    icon: LogIn,
    children: [
      { name: 'As an Author', path: '/author/login', icon: PenLine },
      { name: 'As a Reviewer', path: '/reviewer/login', icon: ClipboardCheck },
    ],
  },
  { name: 'Submit a Paper', path: '/manuscript-submission', icon: Send, isCTA: true },
];

/** Admin nav is explicitly out of scope for theming -- unchanged, rendered by AdminNavbarChrome. */
export const adminNavItems: NavItem[] = [
  { name: 'Home', path: '/' },
  { name: 'Dashboard', path: '/admin/dashboard', icon: Shield },
  { name: 'Submissions', path: '/admin/submissions', icon: AlertCircle },
  { name: 'Articles', path: '/admin/articles', icon: Calendar },
  { name: 'Users', path: '/admin/users', icon: User },
];
